import * as React from "react";
const SVGComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 771 676"
        fill="none"
        {...props}
    >
        <path
            d="M55.7957 261.623L530.259 642.505C593.552 693.321 686.3 683.459 737.35 620.472C788.414 557.485 778.504 465.188 715.16 414.372L240.748 33.4902C177.403 -17.3259 84.7073 -7.45138 33.6435 55.5359C-17.4074 118.522 -7.49858 210.807 55.7957 261.623Z"
            stroke="white"
            strokeWidth={1.5}
        />
    </svg>
);
export default SVGComponent;
